<template>
  <div>
    <div
      v-show="!isShowCalendar && isShowInventory"
      class="calendar-loading-container"
    >
      <CalendarLoader />
    </div>
    <div
      id="calendar-desktop"
      class="calendar-desktop"
      :class="{ 'calendar-animation': !client_session }"
      :style="{ '--my-left': position }"
      v-show="isShowCalendar || !isShowInventory"
    />
    <div
      v-if="isMobile"
      class="calendar__bottom"
      :class="{
        'ios-safari-padding':
          detectIOS() && detectIphoneModel() && !isToolbarOpen,
        'smaller-model': detectIOS() && !detectIphoneModel() && !isToolbarOpen,
      }"
    >
      <div class="calendar__bottom__note">
        <span class="selected">{{
          $t("customhtmlcalendar.selected_date")
        }}</span>
        <span class="not-available">{{
          $t("customhtmlcalendar.not_available")
        }}</span>
        <span class="minimum">{{ $t("customhtmlcalendar.minimum_stay") }}</span>
      </div>
      <div class="calendar__bottom__btn">
        <div id="startDate" class="button" @click="datePicker('start')">
          {{ bookingData.checkIn ? getCheckinDate : $t("booking.check_in") }}
        </div>
        <div id="endDate" class="button" @click="datePicker('end')">
          {{ bookingData.checkOut ? getCheckoutDate : $t("booking.check_out") }}
        </div>
      </div>
      <div class="calendar__bottom__btn-done" @click="clickDoneBtn">
        {{ $t("booking.done") }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */

import Vue from "vue";
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";
import mobiscroll from "mh-date-range";
import Calendar from "./calendarHelper";
import CalendarLoader from "@/components/app-loader/CalendarLoader";
import "mh-date-range/dist/css/mobiscroll.javascript.min.css";

export default Vue.extend({
  name: "",
  components: {
    CalendarLoader,
  },
  props: {
    isShow: Boolean,
    minimumStay: Array,
    container: String,
    subContainer: String,
    calendarContainer: String,
    date: Array,
    lang: {
      type: String,
    },
    hotelCode: {
      type: String,
    },
    isShowInventory: {
      type: Boolean,
      default: true,
    },
    innerHeight: {
      type: Number,
      default: 0,
    },
  },
  data: () => {
    return {
      position: 0,
      calendar: null,
      curentTarget: null,
      showCalendar: false,
      CheckNextDaySetManually: false,
      isSelected: { startDate: false, endDate: false },
      dayUseOnly: false,
      rangeCalendar: null,
      isShowCalendar: false,
      isToolbarOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      getCheckinDate: "getCheckinDate",
      getCheckoutDate: "getCheckoutDate",
      isMobile: "isMobile",
      roomList: "roomList",
      totalNights: "totalNights",
      kidTiers: "kidTiers",
    }),
    ...mapState({
      bookingData: (state) => state.bookingData,
      allowedSelectOneDay: (state) => state.allowedSelectOneDay,
      isCalendarLoading: (state) => state.isCalendarLoading,
      roomActive: (state) => state.currentRoomActive,
      client_session: (state) => state.client_session,
    }),
  },
  watch: {
    isMobile(newValue) {
      if (newValue) {
        this.renderCalendar(this.lang, newValue);
      } else {
        this.renderCalendar(this.lang);
      }
    },
    isShowInventory(value) {
      console.log("value", value);
    },
  },
  mounted() {
    let langFormat = "";
    if (this.lang === "zh_Hant" || this.lang === "zh_Hans") {
      langFormat = "zh";
    } else {
      langFormat = this.lang;
    }
    this.renderCalendar(langFormat, this.isMobile);

    if (this.innerHeight === window.innerHeight) {
      this.isToolbarOpen = true;
    } else {
      this.isToolbarOpen = false;
    }
  },
  methods: {
    ...mapActions({
      setBooking: "setInitialBooking",
      getBooking: "getInitialBooking",
      showRoomSelect: "showRoomSelect",
      setCalendar: "setCalendar",
      getInventory: "getInventory",
      handleGetInventorySuccess: "handleGetInventorySuccess",
    }),

    detectIOS() {
      const isIOS = /iPhone/.test(navigator.userAgent) && !window.MSStream;
      let safariAgent = false;
      if (isIOS) {
        const userAgentString = navigator.userAgent;
        let chromeAgent =
          userAgentString.indexOf("Chrome") > -1 ||
          userAgentString.match("CriOS");
        safariAgent = userAgentString.indexOf("Safari") > -1;

        if (chromeAgent && safariAgent) safariAgent = false;
      }

      return safariAgent;
    },

    detectIphoneModel() {
      const iHeight = window.screen.height;
      const iWidth = window.screen.width;
      let isXSMax = false;

      if (
        (iWidth === 320 && iHeight === 568) ||
        (iWidth === 375 && iHeight === 667) ||
        (iWidth === 414 && iHeight === 736)
      ) {
        isXSMax = false;
      } else isXSMax = true;

      return isXSMax;
    },

    inventoryParams(y, m) {
      return {
        q: {
          checkin_date: "",
          checkout_date: "",
          adults: "",
          children: "",
          nights: this.totalNights,
        },
        hotelID: this.hotelCode,
        year: y,
        month: m,
        roomList: this.roomList,
        roomIndex: this.roomActive,
      };
    },

    datePicker(type) {
      Calendar.datePicker(this, type);
    },
    clickDoneBtn() {
      this.$emit("clickDoneBtn");
    },
    handelCalendar() {
      // if (this.$route.name === "Hotel") {
      //   this.setCalendar(true);
      // }
    },
    renderCalendar(lang, isMobile) {
      let CheckNextDaySetManually = false;
      let langForCalendar = lang || "en-US";
      if (lang === "zh-Hans" || lang === "zh-Hant") {
        langForCalendar = "zh";
      }
      const config = isMobile ? Calendar.mobileConfig : Calendar.desktopConfig;
      this.rangeCalendar = mobiscroll.range(".calendar-desktop", {
        ...Calendar.configDefault,
        ...config,
        // invalid: this.invalidDate,
        lang: langForCalendar,
        fullLang: lang,
        defaultValue: [this.bookingData.checkIn, this.bookingData.checkOut],
        onInit: (_event, inst) => {
          inst.show();
        },
        onMarkupReady: (event, _inst) => {
          const textByLocale = this.$t("customhtmlcalendar");
          Calendar.customHTML(event, textByLocale);
          if (isMobile) {
            Calendar.customHeaderCalendar(event.target, textByLocale);
          }
        },
        onPageLoaded: (event, inst) => {
          const date = new Date(event.firstDay);
          const y = date.getFullYear();
          const m = date.getMonth();
          if (this.isShowInventory) {
            if (this.client_session) {
              Calendar.getAPICalendar(this.inventoryParams(y, m), this.kidTiers)
                .then((res) => {
                  this.handleGetInventorySuccess(res);
                  Calendar.renderInventory(inst);
                  Calendar.renderInvalidDate(inst);
                  this.isShowCalendar = true;
                })
                .catch((err) => (this.isShowCalendar = true));
            } else {
              this.isShowCalendar = true;
            }
          }
          if (isMobile) {
            const textByLocale = this.$t("customhtmlcalendar");
            Calendar.customHeaderCalendar(inst.markup, textByLocale);
          }
        },
        onDayChange: (_event, inst) => {
          setTimeout(() => {
            Calendar.showToolTip(inst, this.$t("customhtmlcalendar"));
          }, 100);
          if (event.active === "end") {
            if (event.date < new Date(inst.startVal)) {
              inst.setVal([event.date, inst.endVal], true);
              return true;
            }
          }
        },
        onPageChange: (_event, inst) => {
          Calendar.renderInventory(inst);
          // Hover logic
          if (!this.isMobile) {
            Calendar.AddIntermediateHoverLogic(inst, CheckNextDaySetManually);
          }
        },
        onSet: (event, inst) => {
          CheckNextDaySetManually = false;
          const startVal = inst.startVal;
          const endVal = inst.endVal;
          const checkinDate = moment(new Date(startVal));
          const checkoutDate = moment(new Date(endVal));

          CheckNextDaySetManually = Calendar.onSetDate(event, inst);

          if (CheckNextDaySetManually) {
            const startVal = inst.startVal;
            const endVal = inst.endVal;
            const checkIn = moment(new Date(startVal)).format("YYYY-MM-DD");
            const checkOut = moment(new Date(endVal)).format("YYYY-MM-DD");
            this.setBooking({ checkIn, checkOut });
            if (this.allowedSelectOneDay) {
              this.showRoomSelect();
            }
          } else {
            const startVal = inst.startVal;
            const endVal = inst.endVal;
            const checkOut = moment(new Date(endVal)).format("YYYY-MM-DD");
            this.setBooking({ checkOut });

            if (startVal === endVal) {
              this.handelCalendar();
            }
            if (!this.isMobile) {
              this.showRoomSelect();
            }
          }
          this.getBooking();
          // // Hover logic
          if (!this.isMobile) {
            Calendar.AddIntermediateHoverLogic(inst, CheckNextDaySetManually);
          }
        },
      });
    },
  },
});
</script>

<style lang="scss">
.calendar-loading-container {
  width: 100%;
  transition: 0.3s ease;
  animation-name: mbsc-anim-p-in;
  animation-duration: 0.3s;
  position: relative;
  background: #fff;
  min-height: calc(100vh - 146px);
  // height: 90vh;

  @include min-sm {
    height: initial;
    min-height: 450px;
  }
}
.calendar-desktop {
  width: 100%;
  transition: 0.3s ease;
  animation-duration: 0.3s;
  position: relative;
}

.calendar-animation {
  animation-name: mbsc-anim-p-in;
  animation-duration: 0.3s;
}

.calendar__bottom {
  position: fixed;
  // top: calc(100vh - 146px);
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 15px;
  width: 100vw;
  background: #fff;
  box-shadow: 0 -1px 15px 0 rgba(0, 0, 0, 0.25);

  // @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
  //   padding-bottom: calc(10px + 2 * env(safe-area-inset-bottom));
  // }

  &__note {
    display: flex;
    margin-bottom: 10px;
    color: #000;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      font-size: 11px;
      font-weight: 600;
      &::before {
        content: "";
        width: 10px;
        height: 10px;
        border: 1px solid #1a489c;
        margin-right: 10px;
      }
    }
    .selected {
      &::before {
        background-color: #1a489c;
      }
    }

    .minimum {
      &::before {
        background: coral;
        border: none;
      }
    }

    .not-available {
      &::before {
        content: "";
        background: linear-gradient(
          to top left,
          #ddd 0%,
          #ddd calc(50% - 0.8px),
          #000 50%,
          #ddd calc(50% + 0.8px),
          #ddd 100%
        );
      }
    }
  }
  &__btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    color: #000;
    .button {
      width: 45%;
      border: 1px solid #ddd;
      padding: 5px 10px;
      text-align: center;
      font-weight: 500;
    }
    .active {
      border: 2px solid #ffd25d;
    }
  }
  &__btn-done {
    width: 100%;
    text-align: center;
    padding: 10px;
    background-color: #ffd25d;
    font-weight: 500;
    text-transform: capitalize;
  }
}

.ios-safari-padding {
  padding-bottom: 70px; // highest in IP
  // padding-bottom: calc(10px + 2 * env(safe-area-inset-bottom));
}

.smaller-model {
  padding-bottom: 40px;
}

.calendar-mobile {
  .calendar {
    &__header {
      display: block;
      margin-bottom: 10px;

      span {
        padding: 5px 10px;
        border-radius: 2px;
        border: 1px solid #dddee0;
        background-color: #ffffff;
        font-weight: 600;
      }
    }
  }

  .mbsc-fr-overlay {
    display: none;
  }

  .mystays-bookingwidget-header {
    padding-bottom: 10px;

    .days {
      font-size: 15px;
      display: flex;
      justify-content: space-between;

      span {
        font-size: 13px;
        color: #737272;
        display: block;
        text-align: center;
        width: 100%;
      }
    }
  }

  .mbsc-range-btn-t {
    display: none;
  }

  .mbsc-cal-days-c {
    display: none;
  }

  .mbsc-fr-persp {
    height: 100vh !important;
  }

  .mbsc-cal-scroll-c {
    overflow: inherit;
  }

  .mbsc-cal-table {
    // margin-top: 240px !important;
    height: auto;
  }

  .mbsc-cal-body {
    height: 100vh;
  }

  .mbsc-cal-hdr {
    display: none;
  }

  .mbsc-fr-c {
    background-color: #fff;
  }

  .mbsc-fr-w {
    border: none !important;
    background: none;
  }

  .mbsc-cal-row {
    .mbsc-cal-day {
      &:last-child {
        .mbsc-cal-cell-i {
          border-right: 0.5px solid #ddd;
        }
      }

      .mbsc-cal-cell-i {
        border-bottom: 0.5px solid #ddd;
        border-left: 0.5px solid #ddd;
      }
    }
  }

  .mbsc-cal-row {
    &:first-child {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-top: 0.5px solid #ddd;
        }
      }
    }
  }

  .mbsc-cal-row {
    &:nth-child(2) {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-top: 0.5px solid #ddd;
        }
      }
    }
  }

  .mbsc-cal-row {
    &:last-child {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-right: 0.5px solid #ddd;
        }
      }
    }
  }

  .mbsc-cal-day-last {
    .mbsc-cal-cell-i {
      border-right: 0.5px solid #ddd;
    }
  }
}

.calendar-desktop {
  box-shadow: 2px 0px 10px 0 rgba(74, 74, 74, 0.25);
  .note {
    display: flex;
    // margin-bottom: 10px;
    padding: 0 30px 20px 30px;
    background-color: #fff;
    border-bottom: 4px solid #ffd25d;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      font-size: 11px;
      font-weight: 600;

      &::before {
        content: "";
        width: 10px;
        height: 10px;
        margin-right: 10px;
        background: coral;
      }
    }

    .selected {
      &::before {
        background-color: #1a489c;
      }
    }

    .minimum {
      &::before {
        background: coral;
      }
    }

    .not-available {
      &::before {
        content: "";
        background: linear-gradient(
          to top left,
          #ddd 0%,
          #ddd calc(50% - 0.8px),
          #000 50%,
          #ddd calc(50% + 0.8px),
          #ddd 100%
        );
      }
    }
  }

  .mbsc-ic::before {
    // content: "";
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 6px 13px 6px 15px;
    font-family: "icomoon" !important;
    font-size: 15px;
  }

  [class*="mbsc-ic-arrow"]::before {
    content: "\e90b";
  }

  [class*="mbsc-ic-arrow-left"] {
    transform: rotate(-180deg);
  }

  .mbsc-range-btn-t {
    display: none;
  }

  .mbsc-fr-overlay {
    display: none;
  }

  .mbsc-fr-c {
    background-color: #fff;
    padding: 20px 20px 0 20px;
  }

  .mbsc-cal-row {
    .mbsc-cal-day {
      &:last-child {
        .mbsc-cal-cell-i {
          border-right: 0.5px solid #ddd;
        }
      }

      .mbsc-cal-cell-i {
        border-bottom: 0.5px solid #ddd;
        border-left: 0.5px solid #ddd;
      }
    }

    &:first-child {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-top: 0.5px solid #ddd;
        }
      }
    }

    &:nth-child(2) {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-top: 0.5px solid #ddd;
        }
      }
    }

    &:last-child {
      .mbsc-cal-day {
        .mbsc-cal-cell-i {
          border-right: 0.5px solid #ddd;
        }
      }
    }

    .mbsc-disabled {
      .mbsc-cal-day-i {
        background: linear-gradient(
          to top left,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) calc(50% - 0.8px),
          #ddd 50%,
          rgba(0, 0, 0, 0) calc(50% + 0.8px),
          rgba(0, 0, 0, 0) 100%
        );
        @media screen and (min-width: 0\0) {
          background: linear-gradient(
            to top left,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            #ddd 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 50%
          );
        }
      }
    }
  }

  .mbsc-cal-day-last {
    .mbsc-cal-cell-i {
      border-right: 0.5px solid #ddd;
    }
  }

  .animate {
    transition: left 0.3s ease-out;
  }

  .mystays-hover-intermediate {
    background: rgba(26, 72, 156, 0.8);
    color: #fff;
  }

  .mbsc-cal-table {
    .mbsc-cal-row {
      &:first-child {
        .mbsc-cal-day {
          .mbsc-cal-cell-i {
            border-bottom: none;
          }
        }
      }
    }
  }

  // .mbsc-cal-sel-start {
  //   background: rgba(26, 72, 156, 1);
  // }
}

.mystays-custom-invalid {
  cursor: not-allowed;
  position: relative;
  pointer-events: none;

  .mbsc-cal-day-i {
    background: linear-gradient(
      to top left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) calc(50% - 0.8px),
      #ddd 50%,
      rgba(0, 0, 0, 0) calc(50% + 0.8px),
      rgba(0, 0, 0, 0) 100%
    );

    .mbsc-cal-day-date {
      opacity: 0.2;
    }
  }
}

.mbsc-selected {
  .mbsc-cal-day-i {
    .mbsc-cal-day-date {
      opacity: 1 !important;
    }
  }
}

.open-invalid {
  pointer-events: all;
  cursor: pointer;

  .mbsc-cal-day-i {
    border: 0.5px solid #000 !important;
  }
  .mbsc-cal-day-date {
    opacity: 1 !important;
  }
}

.mbsc-cal-txt,
.mbsc-cal-txt-ph,
.mbsc-cal-txt-more {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.mbsc-windows .mbsc-cal-txt {
  border: 1px solid #1a489c;
  color: #fff;
  background: none;
}

.mbsc-windows .mbsc-cal-day:not(.mbsc-disabled):hover {
  .mbsc-cal-day-i {
    @media (min-width: 1200px) {
      background: rgba(26, 72, 156, 1) !important;
      color: #fff;
    }
  }
}

.mbsc-windows
  .mbsc-cal
  .mbsc-cal-day.mbsc-selected:not(.mbsc-disabled)
  .mbsc-cal-cell-i.mbsc-cal-day-i,
.mbsc-windows.mbsc-range
  .mbsc-cal
  .mbsc-cal-today.mbsc-cal-day-hl
  .mbsc-cal-day-date {
  background-color: #1a4699;
  color: #fff;
}

.mbsc-windows .mbsc-cal-day-date {
  line-height: 2.8em;
}

.tool-tip {
  animation-name: mbsc-anim-p-in;
  animation-duration: 0.5s;
  width: 86px;
  height: 35px;
  text-align: center;
  padding-top: 6px;
  background: #232e48;
  color: #fff;
  position: absolute;
  bottom: calc(100% + 15px);
  right: -20px;
  border: 1px solid #232e48;
  border-radius: 2px;
  z-index: 20;
  &::after {
    content: "";
    width: 14px;
    height: 14px;
    position: absolute;
    background: #232e48;
    bottom: -7px;
    left: 35px;
    z-index: -1;
    transform: rotate(45deg);
  }
}

.tool-tip-show-bottom {
  animation-name: mbsc-anim-p-in;
  animation-duration: 0.5s;
  width: 86px;
  height: 35px;
  text-align: center;
  padding-top: 6px;
  background: #232e48;
  color: #fff;
  position: absolute;
  top: calc(100% + 15px);
  right: -20px;
  border: 1px solid #232e48;
  border-radius: 2px;
  z-index: 30;
  &::after {
    content: "";
    width: 14px;
    height: 14px;
    position: absolute;
    background: #232e48;
    top: -7px;
    left: 35px;
    z-index: -1;
    transform: rotate(45deg);
  }
}

.tool-tip-right {
  right: -5px;
  &::after {
    left: 55px;
  }
}

.tool-tip-left {
  right: -35px;
  &::after {
    left: 15px;
  }
}
</style>
